import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {SettingsDirectoryService} from '../../../services/settings-directory.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'directory-reminders-modal',
    templateUrl: './directory-reminders-modal.component.html',
    styleUrls: ['./directory-reminders-modal.component.scss']
})
export class DirectoryRemindersModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    disabledSubmit = false;
    step = 'details';
    data = {
        title: '',
        description: '',
        conditionDefinition: {
            value: null,
            name: '',
            isAfter: true
        },
        enableStatus: true,
        forStaff: true,
        conditionField: 'invitedAt',
        subject: '',
        template: '',
        userRoles: []
    };
    timingSelectValues = [
        {value: 'minute', displayName: 'Minutes'},
        {value: 'hour', displayName: 'Hours'},
        {value: 'day', displayName: 'Days'}
    ];
    conditionFieldsSelectValues = [
        {value: 'invitedAt', displayName: 'Invitation'}
    ];
    placeholders = [
        '[[RESIDENT_MOBILE_PHONE]]',
        '[[RESIDENT_HOME_PHONE]]',
        '[[RESIDENT_BUSINESS_PHONE]]',
        '[[RESIDENT_NAME]]',
        '[[RESIDENT_EMAIL]]',
        '[[BUILDING_NAME]]',
        '[[BUILDING_ADDRESS]]',
        '[[INVITATION_LINK]]',
        '[[MY_SIGNATURE]]',
        '[[DATA_CONFIRMATION_LINK]]'
    ];
    showUsersSpinner = false;
    users: Array<any> = [];
    multiselectSettings = {
        singleSelection: false,
        text: 'Select',
        selectAllText: 'Select All',
        unSelectAllText: 'Deselect All',
        enableSearchFilter: true
    };
    useInvitationTemplate = false;

    constructor(
        public api: ApiClientService,
        public settingsDirectoryService: SettingsDirectoryService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.initData();
        this.getUsers();
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initData() {
        if(this.settingsDirectoryService.selectedReminderIndex !== null) {
            const item = this.settingsDirectoryService.selectedItemData.reminders[this.settingsDirectoryService.selectedReminderIndex];
            this.data = {
                title: item.title,
                description: item.description,
                conditionDefinition: {
                    value: item.conditionDefinition.value,
                    name: item.conditionDefinition.name,
                    isAfter: item.conditionDefinition.isAfter
                },
                conditionField: item.conditionField,
                forStaff: item.forStaff,
                enableStatus: item.enableStatus,
                subject: item.subject,
                template: item.template,
                userRoles: item.userRoles.map(u => ({
                    id: u.bdId,
                    itemName: u.roleName
                }))
            };
        }
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.settingsDirectoryService.isRemindersModalShow = false;
                    this.settingsDirectoryService.selectedReminderIndex = null;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.settingsDirectoryService.isRemindersModalShow = false;
            this.settingsDirectoryService.selectedReminderIndex = null;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        this.disabledSubmit = true;
        const data = {reminders: this.getRemindersFormatted()};
        const url = `/v1/corporation_number/${this.settingsDirectoryService.selectedItemData.id}.json?expand=reminders`;
        this.api.patch('domainBD', url, data).subscribe(
            (res) => {
                this.settingsDirectoryService.selectedItemData = res;
                this.updateView('The Field was successfully updated');
            },
            error => this.api.errorHandler(error, 'Update failed!'),
            () => this.disabledSubmit = false
        );
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.settingsDirectoryService.getCorporations();
        this.form.reset();
        this.hideModal();
    }

    moveToTheNextStep(moveTo): void {
        this.step = moveTo;
        if(this.step == 'notification')
            setTimeout( () => this.initSummernote(), 300);
    }

    calculateCurrentProgressBarLength(): string {
        let width = '17%';

        if(this.step == 'conditions')
            width = '50%';
        else if(this.step == 'notification')
            width = '83%';

        return width;
    }

    isContinueButtonDisabled(step): boolean {
        let isDisabled = false;
        if(step == 'details') {
            if(!this.data.title)
                isDisabled = true;
        } else if(step == 'conditions') {
            if(!this.data.conditionDefinition.value || !this.data.conditionDefinition.name ||
               !this.data.conditionField || !(/^[0-9]*$/.test(this.data.conditionDefinition.value)))
                isDisabled = true;
        } else if(step == 'notification') {
            if(!this.data.subject || !this.data.template)
                isDisabled = true;
        }
        return isDisabled;
    }

    initSummernote() {
        const summernote = $('#summernote');
        summernote.summernote({
            dialogsInBody: true,
            callbacks: { onChange: contents => this.data.template = contents },
            toolbar: [
                ['style', ['style']],
                ['fontsize', ['fontsize']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['help', ['help']],
                ['table', ['table']],
                ['insert', ['link', 'hr']]
            ],
            fontNames: ['Arial', 'open sans', 'Courier New'],
            disableDragAndDrop: true
        });
        $('.note-btn-bold').removeClass('active');

        const btn = `
            <div class="input-group-btn email-placeholders-btn">
                <button data-toggle="dropdown" class="btn btn-sm btn-white dropdown-toggle" 
                        type="button" aria-expanded="false">PL <span class="caret"></span></button>
                <ul class="dropdown-menu pull-right">${this.getPlaceholdersHtml()}</ul>
            </div>
        `;

        $(btn).insertAfter('[data-original-title="Help"]')
            .on('click', 'li a', e => {
                summernote.summernote('editor.restoreRange');
                summernote.summernote('editor.focus');
                summernote.summernote('editor.insertText', e.target.innerText);
            });
        $('.note-editable').html(this.data.template).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });
        $('.note-editable').html(this.data.template).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });
    }

    getPlaceholdersHtml(): string {
        return this.placeholders.map(item => `<li><a>${item}</a></li>`).join('');
    }

    getRemindersFormatted() {
        let data = [];
        this.data.userRoles = this.data.userRoles.map(u => ({
            ...u,
            bdId: u.id,
            roleName: u.name || u.roleName || u.itemName
        }));
        if(this.settingsDirectoryService.selectedItemData.reminders.length > 0) {
            if(this.settingsDirectoryService.selectedReminderIndex === null)
                data = this.settingsDirectoryService.selectedItemData.reminders.concat(this.data);
            else {
                this.settingsDirectoryService.selectedItemData.reminders.splice(this.settingsDirectoryService.selectedReminderIndex, 1, this.data);
                data = this.settingsDirectoryService.selectedItemData.reminders;
            }
        } else {
            data = [this.data];
        }

        return data.map(item => ({
            title: item.title,
            description: item.description,
            conditionDefinition: {
                value: item.conditionDefinition.value,
                name: item.conditionDefinition.name,
                isAfter: item.conditionDefinition.isAfter
            },
            conditionField: item.conditionField,
            subject: item.subject,
            template: item.template,
            forStaff: item.forStaff,
            enableStatus: item.enableStatus,
            userRoles: !item.forStaff ? [] : item.userRoles.map(u => ({
                bdId: u.bdId,
                roleName: u.roleName
            }))
        }));
    }

    getUsers() {
        this.showUsersSpinner = true;
        const url = `/api/v1/role.json?per-page=10000`;
        this.api.get('oauthUrl', url).subscribe(res => {
                const body = JSON.parse(res._body);
                this.users = body.entities || [];
                this.users = this.users.filter(u => u.corporationNumberId == this.settingsDirectoryService.selectedItemData.id);
                this.users = this.users.map(u => ({
                    ...u,
                    itemName: u.name
                }));
            },
            error => this.api.errorHandler(error, 'Failed get Users'),
            () => this.showUsersSpinner = false
        );
    }

    useInvitationTemplateChanged(event) {
        if(event) {
            this.data.template = this.settingsDirectoryService.selectedItemData.inviteTemplate || '';
            $('#summernote').summernote('destroy');
            this.initSummernote();
        }
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-directory/directory-reminders-modal/directory-reminders-modal.component.ts